import { gql } from "@stadium/services/apollo-client";
import { OPTION_VALUES_SERVER } from "@graphql/fragments/product/server/option-values";

export const OPTION_VALUES = gql`
  ${OPTION_VALUES_SERVER}
`;
